import React from "react";
import { Navigate, useLocation } from "react-router";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuth } from "src/providers/AuthProvider";
import { DASHBOARD_PATH, LOGIN_PATH } from "src/constants/paths";

const RequireAuth: React.FC<{
  children: React.ReactNode;
  adminOnly?: boolean;
}> = ({ children, adminOnly = false }) => {
  const { t } = useTranslation();
  const { status, isAdmin } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <Box
        role="status"
        aria-label={t("auth.checkingSession")}
        sx={{
          flex: 1,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: 8,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (status === "anonymous") {
    const next = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`${LOGIN_PATH}?next=${encodeURIComponent(next)}`}
        replace
      />
    );
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to={DASHBOARD_PATH} replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
